import { createFileRoute, redirect } from "@tanstack/react-router";

import { DISCORD_INVITE_URL } from "#/lib/discordInvite";

export const Route = createFileRoute("/discord")({
  beforeLoad: () => {
    throw redirect({ href: DISCORD_INVITE_URL, statusCode: 302 });
  },
});
